'use strict';

const BaseSelectMenuComponent = require('./BaseSelectMenuComponent');

/**
 * Represents a user select menu component
 * @extends {BaseSelectMenuComponent}
 */
class UserSelectMenuComponent extends BaseSelectMenuComponent {}

module.exports = UserSelectMenuComponent;
